<template>
  <b-modal
    :visible="value"
    :title="title"
    ok-only
    ok-title="Filtrar"
    size="xl"
    @hide="$emit('input', false)"
    @ok="saveFilters"
  >
    <b-row>
      <b-col v-show="showStoreFilters">
        <FilterSelectorLogic
          ref="storeFilters"
          :hierarchy-filters="storeFilters"
          :selected-filters="selectedStoreFilters"
          :underlined-class="false"
          :disabled-filters="disabledStoreDimensionIds"
        />
      </b-col>
      <b-col v-show="showProductFilters">
        <FilterSelectorLogic
          ref="productFilters"
          :hierarchy-filters="productFilters"
          :selected-filters="selectedProductFilters"
          :underlined-class="false"
          :disabled-filters="disabledProductDimensionIds"
        />
        <AsyncProductMultiselect
          ref="asyncProductFilters"
          :selected-async-product-filters="selectedAsyncProductFilters"
          :async-product-pool="asyncProductPool"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import FilterSelectorLogic from '@/app/shared/components/FilterSelectorLogic'
import AsyncProductMultiselect from '@/app/shared/components/async_product_multiselect/Index'

export default {
  name: 'TheModalFilters',
  components: {
    FilterSelectorLogic,
    AsyncProductMultiselect
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Filtros'
    },
    asyncProductPool: {
      type: Array,
      required: false,
      default: () => {}
    },
    selectedStoreFilters: {
      type: Object,
      required: false,
      default: () => {}
    },
    selectedProductFilters: {
      type: Object,
      required: false,
      default: () => {}
    },
    selectedAsyncProductFilters: {
      type: Object,
      required: false,
      default: () => {}
    },
    disabledStoreDimensionIds: {
      type: Array,
      required: false,
      default: () => []
    },
    disabledProductDimensionIds: {
      type: Array,
      required: false,
      default: () => []
    },
    showStoreFilters: {
      type: Boolean,
      required: false,
      default: true
    },
    showProductFilters: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    storeFilters () {
      return this.$store.getters.storeFilters
    },
    productFilters () {
      return this.$store.getters.productCategoryFilters
    }
  },
  methods: {
    saveFilters () {
      const storeFilters = this.$refs.storeFilters.buildFilters()
      const productFilters = this.$refs.productFilters.buildFilters()
      const asyncProductFilters = this.$refs.asyncProductFilters.buildFilters()
      const asyncProductPool = asyncProductFilters.data.selection
      const selectedFilters = { storeFilters, productFilters, asyncProductPool }
      selectedFilters.productFilters.product_id = asyncProductFilters.productFilters
      this.$emit('save-filters', selectedFilters)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/shared/components/TheModalFilters.vue